const skills = [
    {
        "id": 1,
        "name": "Node.js",
        "logo": "nodejs-logo.png",
    },
    {
        "id": 2,
        "name": "JavaScript",
        "logo": "javascript-js-logo.png",
    },
    {
        "id": 3,
        "name": "MySQL",
        "logo": "MySQL-logo.png",
    },
    {
        "id": 4,
        "name": "Python",
        "logo": "python-logo.png",
    },
    {
        "id": 5,
        "name": "React",
        "logo": "react-logo.png",
    },
    {
        "id": 6,
        "name": "HTML 5",
        "logo": "html5-logo.png",
    },
    {
        "id": 7,
        "name": "CSS 3",
        "logo": "css-3-logo.png",
    },
    {
        "id": 8,
        "name": "Sass",
        "logo": "sass-logo.png",
    },
]

export default skills